import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import DashboardCard from "../dashboard/components/DashboardCard";
import { Icon } from "../../components/common/Icon";
import { FaWhatsapp, FaUserPlus, FaBuilding, FaEnvelope, FaSms, FaHashtag, FaComments, FaChartLine } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const MarketingHome: React.FC = () => {
  const { t } = useTranslation();

  const dashboardData = {
    whatsappChatbots: 8,
    leadGeneration: 145,
    companyResearch: 24,
    emailMarketing: 32,
    whatsappMarketing: 17,
    socialMedia: 56,
    communicationsHub: 93,
  };

  return (
    <Container fluid className="marketing-dashboard">
      <div className="page-header">
        <div className="header-content">
          <div className="header-info">
            <div className="header-icon">
              <Icon icon={FaChartLine} />
            </div>
            <div className="header-text">
              <h1 className="page-title">{t("marketing")}</h1>
              <p className="page-subtitle">{t("marketing_subtitle")}</p>
            </div>
          </div>
        </div>
      </div>

      <Card className="content-card">
        <Card.Header className="card-header-custom">
          <div className="section-header">
            <div className="section-icon tools-icon">
              <i className="bi bi-tools"></i>
            </div>
            <h5 className="section-title">{t("marketing_tools")}</h5>
          </div>
        </Card.Header>
        <Card.Body className="card-body-custom">
          <Row xs={1} sm={2} md={3} lg={4} className="g-4">
            <Col>
              <DashboardCard
                title={t("whatsapp_chatbots")}
                icon={<Icon icon={FaWhatsapp} size={24} />}
                count={dashboardData.whatsappChatbots}
                color="#1cc88a"
                path="/marketing/whatsapp-chatbots"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("lead_generation")}
                icon={<Icon icon={FaUserPlus} size={24} />}
                count={dashboardData.leadGeneration}
                color="#f6c23e"
                path="/marketing/lead-generation"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("company_research")}
                icon={<Icon icon={FaBuilding} size={24} />}
                count={dashboardData.companyResearch}
                color="#e74a3b"
                path="/marketing/company-research"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("email_marketing")}
                icon={<Icon icon={FaEnvelope} size={24} />}
                count={dashboardData.emailMarketing}
                color="#36b9cc"
                path="/marketing/email-marketing"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("whatsapp_marketing")}
                icon={<Icon icon={FaSms} size={24} />}
                count={dashboardData.whatsappMarketing}
                color="#6f42c1"
                path="/marketing/whatsapp-marketing"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("social_media")}
                icon={<Icon icon={FaHashtag} size={24} />}
                count={dashboardData.socialMedia}
                color="#fd7e14"
                path="/marketing/social-media-management"
                comingSoon={true}
              />
            </Col>
            <Col>
              <DashboardCard
                title={t("communications_hub")}
                icon={<Icon icon={FaComments} size={24} />}
                count={dashboardData.communicationsHub}
                color="#20c997"
                path="/marketing/communications-hub"
                comingSoon={true}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default MarketingHome;


